import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../utilities/string'
import { MetricValues } from './KeyMetrics'

export interface KeyMetricsListProps {
  additionalClassName?: string
  keyMetrics: MetricValues[]
  showTitleInMobile?: boolean
  title?: string
}

export const KeyMetricsList = ({
  additionalClassName,
  keyMetrics,
  showTitleInMobile = false,
  title,
}: KeyMetricsListProps): JSX.Element => (
  <div
    className={classNames(
      'flex flex-col gap-20 tb:gap-7 md:w-480 xl:w-[31.25rem]',
      additionalClassName
    )}
  >
    {!isNullOrWhiteSpace(title) && (
      <h3
        className={classNames(
          'font-t text-t-300 text-primary',
          'tb:block',
          'xl:text-t-400',
          {
            'hidden': !showTitleInMobile,
          }
        )}
      >
        {title}
      </h3>
    )}

    <div
      className={classNames(
        'w-150 flex flex-col justify-between items-center space-y-10 text-secondary-dark',
        'tb:w-330 tb:flex-row tb:my-0 tb:space-y-0 tb:space-x-15',
        'md:w-[22.5rem]',
        'xl:w-[27.8125rem]'
      )}
    >
      {keyMetrics.map(metric => (
        <div
          key={metric.metricTitle.toLowerCase()}
          className="flex items-center max-w-150 tb:first:justify-end xl:max-w-[10.3125rem]"
        >
          {/* Use justify-end here to overflow to the left instead, where there's more space available above tb */}
          <span
            className={classNames(
              'flex justify-end flex-shrink-0 min-w-60 mr-15 font-t-light text-t-700',
              'tb:flex-grow-0 tb:min-w-45',
              'md:mr-30 md:text-t-800',
              'xl:min-w-60 xl:max-w-75 xl:text-t-900'
            )}
          >
            <span className="min-w-full flex-shrink-0">{metric.metricValue}</span>
          </span>

          <span className="w-75 flex-grow-0 font-t-bold text-t-300 xl:text-t-500">
            {metric.metricTitle}
          </span>
        </div>
      ))}
    </div>
  </div>
)
